import { defineMessages } from 'react-intl.macro';

import { FormattedMessage } from 'react-intl';

import { DangerAlert } from '@tmapy/style-guide';

import { MainContent } from './MainContent';

import type { FallbackRender } from '@sentry/react';

export { ErrorBoundary } from '@sentry/react';

const msg = defineMessages({
  title: {
    id: 'errorBoundary.title',
    defaultMessage: 'Jejda! Stala se chyba :(',
  },
  unknownError: {
    id: 'errorBoundary.unknownError',
    defaultMessage: 'Neznámá chyba',
  },
});

export const renderDefaultError: FallbackRender = ({ error }) => {
  const errorMessage =
    error instanceof Error ? error.message : <FormattedMessage {...msg.unknownError} />;

  return (
    <MainContent>
      <DangerAlert>
        <b className='sg-u-type-bold'>
          <FormattedMessage {...msg.title} />
        </b>
        <p className='sg-a-mt-1/2'>{errorMessage}</p>
      </DangerAlert>
    </MainContent>
  );
};
